export default __webpack_public_path__ + "static/media/arrow_down.c622c76e.svg";